import { combineReducers } from 'redux';
import { userReducer } from './user';
import { deviceTypeReducer } from './deviceType';
import { abGroupReducer } from './abGroup';
import { experimentsReducer } from './experiments';
import { phoneReducer } from './phone';
import { otpModalReducer } from './otpModal';
import { otpReducer } from './otp';
import { trackLabelReducer } from './trackLabel';
import { mortgageBanksDataReducer } from './mortgageBanksData';
import { pageTypeReducer } from './pageType';
import { suburbanReducer } from './suburban';
import { mediaReducer } from './media';

export const reducers = combineReducers({
  trackLabel: trackLabelReducer,
  mortgageBanksData: mortgageBanksDataReducer,
  phone: phoneReducer,
  otp: otpReducer,
  otpModal: otpModalReducer,
  deviceType: deviceTypeReducer,
  user: userReducer,
  abGroup: abGroupReducer,
  experiments: experimentsReducer,
  pageType: pageTypeReducer,
  suburban: suburbanReducer,
  media: mediaReducer,
});
